import { utils } from "@deltasge/marauders-map";
import { Avatar, Box, IconButton, useTheme } from "@mui/material";
import { snack } from "components/GlobalSnackbar";
import React, { FC, useState } from "react";
import { useEffectOnce } from "react-use";
import { getError, loadS3File } from "utils";
import Lightbox from "yet-another-react-lightbox";

export const ChatImage: FC<{ src: string }> = ({ src: init }) => {
  const [open, setOpen] = useState(false);
  const [src, setSrc] = useState(init);
  const theme = useTheme();

  useEffectOnce(() => {
    (async () => {
      try {
        if (
          src &&
          src.indexOf("https") == -1 &&
          !utils.isBase64(src, { allowMime: true })
        ) {
          const { error, processed } = await loadS3File(src);
          if (processed) setSrc(processed);
          else if (error) {
            throw new Error(error);
          }
        }
      } catch (error) {
        snack.error(getError(error));
      }
    })();
  });

  return (
    <Box>
      <Lightbox
        render={{ buttonPrev: () => null, buttonNext: () => null }}
        controller={{ closeOnBackdropClick: true }}
        open={open}
        index={0}
        slides={[src].map((src) => ({ src }))}
        close={() => setOpen(false)}
      />
      <IconButton onClick={() => setOpen(true)}>
        <Avatar
          src={src}
          variant="square"
          sx={{
            width: "100%",
            height: theme.spacing(18),
          }}
        />
      </IconButton>
    </Box>
  );
};
